var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-select',{attrs:{"disabled":!_vm.show_to,"options":_vm.get_options_simple('order_production_status')},model:{value:(_vm.model.to_order_production_status_id),callback:function ($$v) {_vm.$set(_vm.model, "to_order_production_status_id", $$v)},expression:"model.to_order_production_status_id"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }